import { FlowFormData } from '@/features/campaigns/components/CreateCampaign_v2/steps/Whatsapp/types';

/**
 * The comuni catalog names its fields after the Meta connector's form. Whatsapp Business declares
 * the same things under Gupshup's own names, so a prefill aimed at the Meta ids lands on none of
 * them: the form comes up empty and whoever is creating the template retypes the body by hand.
 * That is how a body with named placeholders reaches a connector that only accepts positional
 * ones, and how six prefilled examples end up beside a body with a different number of variables.
 */
const WHATSAPP_BUSINESS_FIELDS: Record<string, string> = {
  template_name: 'element_name',
  template_body_text: 'content',
  template_header_text: 'header',
  template_footer_text: 'footer',
  template_language: 'language_code',
  template_category: 'category',
};

/** Gupshup requires a "vertical" — the use case a template serves — that the catalog has no field for. */
const WHATSAPP_BUSINESS_VERTICAL = 'Comunicazioni Comune';

/** Rewrite a catalog prefill into the field ids the Whatsapp Business form declares. */
export const toWhatsappBusinessFields = (
  formData: Record<string, FlowFormData> | undefined
): Record<string, FlowFormData> | undefined => {
  if (!formData) {
    return formData;
  }
  return Object.fromEntries(
    Object.entries(formData).map(([step, values]) => [
      step,
      {
        vertical: WHATSAPP_BUSINESS_VERTICAL,
        ...Object.fromEntries(
          Object.entries(values as Record<string, unknown>)
            // parameter_format has no counterpart: Whatsapp Business is positional by construction.
            .filter(([key]) => key !== 'parameter_format')
            .map(([key, value]) => [WHATSAPP_BUSINESS_FIELDS[key] ?? key, value])
        ),
      } as FlowFormData,
    ])
  );
};

/**
 * Map a SYSTEM_MODELS catalog payload onto the Insert Template step keys for the active connector.
 * Meta: template fields live on step2 (step1 is WABA). Business: single-step insert on step1.
 */
export const toWhatsappInsertPrefill = (
  catalogStepData: FlowFormData | undefined,
  usesBusiness: boolean
): Record<string, FlowFormData> | undefined => {
  if (!catalogStepData) {
    return undefined;
  }
  if (usesBusiness) {
    return toWhatsappBusinessFields({ step1: catalogStepData });
  }
  return { step2: catalogStepData };
};
